import { render, staticRenderFns } from "./EmployeeDetails.vue?vue&type=template&id=4586e224&scoped=true&"
import script from "./EmployeeDetails.vue?vue&type=script&lang=ts&"
export * from "./EmployeeDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586e224",
  null
  
)

export default component.exports